import { useEffect } from "react";
import { authService } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import useCustomParams from "../../hooks/core/useCustomParams";
import Loader from "../../components/ui/Loader";
import useToken from "../../hooks/features/auth/useToken";
import { User } from "../../types/features/User";
import useAuth from "../../hooks/features/auth/useAuth";

export default function RedirectPage() {
  const { token  , izilife_token} = useCustomParams();
  const navigate = useNavigate();
  const { saveToken } = useToken();
  const { setUser } = useAuth();
  const allowedRoles = ["admin", "entreprise", "agent"]

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!token || !izilife_token) {
          navigate("/denied");
          return;
        }

        const currentUser: User | null = await authService.getCurrentUser(token , izilife_token);
        console.log(currentUser);

        if (currentUser) {
          const { role } = currentUser;
          if (allowedRoles.includes(role)) {
            saveToken(token);
            setUser(currentUser);
            navigate(`/${role}/dashboard`);
          } else {
            // Rediriger vers denied pour les non-admin
            navigate("/denied");
          }
        } else {
          navigate("/denied");
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de l'utilisateur:", err);
        navigate("/denied");
      }
    };

    fetchUser();
  }, [token, navigate, saveToken]);

  return <Loader />;
}
